import script from "./BasicInfoTab.vue?vue&type=script&setup=true&name=BasicInfoTab&lang=js"
export * from "./BasicInfoTab.vue?vue&type=script&setup=true&name=BasicInfoTab&lang=js"

import "./BasicInfoTab.vue?vue&type=style&index=0&id=aa4a58a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa4a58a4"]])

export default __exports__